<template>
    <div v-if="dataLoaded">
        <h3 class="mb-4">
            Foro
            <b-button
                v-if="isUserStudentOrBetter"
                class="ml-2"
                variant="primary"
                @click="onCreateUpdate(null)"
            >
                <b-icon-plus /> Agregar Tema
            </b-button>
        </h3>

        <template v-if="getActiveSiteForumPosts">
            <b-card
                v-for="forumPost in getActiveSiteForumPosts"
                :key="`forumPost-${forumPost.id}`"
                class="my-2"
            >
                <b-card-text
                    class="clickable"
                    @click="onDisplayDetails(forumPost)"
                >
                    <h4>{{ forumPost.title }}</h4>
                </b-card-text>

                <template v-slot:footer>
                    <div class="float-right">
                        {{ forumPost.authorName }} - {{ forumPost.latestUpdateDate }}
                    </div>

                    <b-button
                        v-if="isUserStudenTeacherOrBetter || forumPost.authorId === userData.id"
                        variant="danger"
                        size="sm"
                        class="ml-2"
                        @click="onDelete(forumPost)"
                    >
                        <b-icon-trash-fill />
                    </b-button>
                </template>
            </b-card>
        </template>
        <p v-else>No existe ningun tema de foro para este sitio web.</p>

        <!-- Create/Update Forum Post Modal -->
        <ForumCreateUpdateModal @reloadForumPostData="loadSiteForumPosts()"/>

        <!-- Forum Post Details Modal -->
        <ForumPostDetailsModal />

    </div>
</template>

<script>
import ForumCreateUpdateModal from './ForumCreateUpdateModal'
import ForumPostDetailsModal from './ForumPostDetailsModal'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'SiteForums',
    components: {
        ForumCreateUpdateModal,
        ForumPostDetailsModal
    },
    data () {
        return {
            dataLoaded: false
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'userData',
            'selectedCrudObject'
        ]),
        ...mapGetters([
            'isUserStudenTeacherOrBetter',
            'isUserStudentOrBetter',
            'getActiveSiteForumPosts'
        ])
    },
    methods: {
        ...mapActions([
            'readCourseSiteForumPosts',
            'deleteSiteForumPost'
        ]),
        async loadSiteForumPosts () {
            let loader = null
            try {
                loader = this.$loading.show()
                await this.readCourseSiteForumPosts(this.activeSite.id)
                this.dataLoaded = true
            } catch (err) {
                console.log(err)
                this.dataLoaded = false
                this.unknownErrorToast()
            } finally {
                loader.hide()
            }
        },
        onDisplayDetails (forumObject) {
            this.$store.commit('SET_SELECTED_FORUM_POST_OBJECT', forumObject)
            this.$bvModal.show('modal-details-forum')
        },
        onCreateUpdate (forumObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', forumObject)
            this.$bvModal.show('modal-create-forum')
        },
        async onDelete (forumObject) {
            this.$store.commit('SET_SELECTED_CRUD_OBJECT', forumObject)
            try {
                let value = await this.$bvModal.msgBoxConfirm(
                    'Por favor confirme que desea eliminar el tema del foro.', {
                        title: 'Confirmar',
                        okVariant: 'danger',
                        okTitle: 'Confirmar',
                        cancelTitle: 'Cancelar',
                        centered: true
                    }
                )
                if (value) {
                    await this.onConfirmDelete()
                } else {
                    this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onConfirmDelete () {
            var loader = null
            try {
                loader = this.$loading.show()
                const payloadData = { courseSiteId: this.activeSite.id, forumPostId: this.selectedCrudObject.id }
                await this.deleteSiteForumPost(payloadData)
                this.$store.commit('DELETE_FORUM_POST_OBJECT', this.selectedCrudObject.id)
                this.$root.infoToast('El foro ha sido eliminado exitosamente.')
            } catch (error) {
                console.log({ error: error })
                this.$root.dangerToast('No se pudo eliminar el foro, intente más tarde.')
            } finally {
                loader.hide()
                this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
            }
        }
    },
    async created () {
        this.$store.commit('RESET_SELECTED_CRUD_OBJECT')
        await this.loadSiteForumPosts()
    }
}
</script>
